export default __webpack_public_path__ + "static/media/home-about-us-1.d0b83fef.jpeg";